<app-header [(menuOpen)]="menuOpen" />
<div class="body">
    @if (menuOpen()) {
        <button type="button" class="backdrop" [attr.aria-label]="'header.menu.close' | translate" (click)="menuOpen.set(false)"></button>
    }
    <app-sidebar [class.open]="menuOpen()" (picked)="menuOpen.set(false)" />
    <div class="content">
        <main>
            <router-outlet />
        </main>
        <app-footer />
    </div>
</div>
